import React from "react";
import { Icon, Popup, Button } from "semantic-ui-react";

const IconMenu = ({
  popUpText,
  inDelay = 500,
  popUpInverted = true,
  popUpProps,
  iconProps,
}) => {
  return (
    <Popup
      content={popUpText}
      inverted={popUpInverted}
      mouseEnterDelay={inDelay}
      trigger={<Button className="actionButton" icon><Icon {...iconProps} /></Button>}
      {...popUpProps}
    />
  );
};

export default IconMenu;
